import dayjs from "dayjs";
import {
  canUnsubscribe,
  deriveSubscriptionState,
  subscriptionSubtitle,
} from "@components/PayRangeSubscriptionCard/payRangeSubscriptionCardUtils";
import { formatFairPayDate } from "@components/utils/fairPayFormat";

export const UNSUBSCRIBE_BODY =
  "You'll stop receiving pay range updates for this position. You can resubscribe at any time.";

export function toIsoDate(value) {
  if (!value) return null;
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : null;
}

export function addOneDay(isoDate) {
  if (!isoDate) return null;
  const parsed = dayjs(isoDate);
  return parsed.isValid() ? parsed.add(1, "day").format("YYYY-MM-DD") : null;
}

export function minEffectiveTo(effectiveFrom) {
  return toIsoDate(effectiveFrom);
}

export function defaultEffectiveTo(effectiveFrom) {
  return addOneDay(effectiveFrom);
}

export function isEffectiveToValid(effectiveTo, effectiveFrom) {
  const min = minEffectiveTo(effectiveFrom);
  if (!effectiveTo || !min) return false;
  return effectiveTo >= min;
}

export function formatEffectiveToLabel(isoDate) {
  return formatFairPayDate(isoDate);
}

export function buildUnsubscribeTitle(payRangeName) {
  const name = String(payRangeName || "").trim();
  return name ? `Unsubscribe from ${name}?` : "Unsubscribe from Pay Range?";
}

export function buildUnsubscribeMetaLine({
  payRangeCode,
  payRangeName,
  effectiveFrom,
  effectiveTo,
  today,
} = {}) {
  const code = String(payRangeCode || "").trim();
  const name = String(payRangeName || "").trim();
  const state = deriveSubscriptionState(effectiveFrom, effectiveTo, today);
  const windowLabel = subscriptionSubtitle(state, effectiveFrom, effectiveTo);
  return [code, name, windowLabel].filter(Boolean).join(" · ");
}

export function canUnsubscribeSubscription(effectiveFrom, effectiveTo, asOfDate) {
  return canUnsubscribe(deriveSubscriptionState(effectiveFrom, effectiveTo, asOfDate));
}
